module.exports = __webpack_public_path__ + "img/validation.ac9bf55a.png";